module.exports = __webpack_public_path__ + "static/media/pta4.4a6cb7aa.png";